module.exports = __webpack_public_path__ + "img/btn_phone_home@3x.6e7b26a3.png";